var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        persistent: _vm.dialog.persistent,
        fullscreen: _vm.dialog.fullscreen,
        "max-width": _vm.dialog.maxWidth
      },
      model: {
        value: _vm.dialog.value,
        callback: function($$v) {
          _vm.$set(_vm.dialog, "value", $$v)
        },
        expression: "dialog.value"
      }
    },
    [
      _c(
        "v-card",
        [
          _vm.dialog.title
            ? _c("v-card-title", { staticClass: "primary white--text title" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm._f("cap")(_vm.dialog.title)) +
                    "\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("v-card-text", [
            _vm._v(
              "\n      " + _vm._s(_vm._f("cap")(_vm.dialog.text)) + "\n    "
            )
          ]),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _vm.dialog.info
                ? _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.cancel()
                        }
                      }
                    },
                    [_vm._v("OK")]
                  )
                : _c(
                    "div",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { flat: "" },
                          on: {
                            click: function($event) {
                              return _vm.cancel()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t(_vm.dialog.cancel)))]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.submit()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t(_vm.dialog.submit)))]
                      )
                    ],
                    1
                  )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ad24fc08", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad24fc08","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzDialog.vue
// module id = null
// module chunks = 